import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import ClientFarmSearch from '../../clients/forms/search';
import { useTransferFarm } from '../contexts/farm-moves';

import './styles/transfer-farm.css';

const today = () => new Date().toLocaleDateString('en-CA');

// Traslado de finca (admin-animals.md · 0036). Cambio de UBICACIÓN puro: body { to_farm_id,
// date, remarks? }. Setea current_farm_id + bitácora; NO toca manejos/pensión (eso va por Estadías).
export default function TransferFarmForm({ animalId, currentFarm, onClose, onSaved }) {
    const { mutateAsync: transfer, isPending: busy } = useTransferFarm(animalId);
    const cardRef = useModalDialog(onClose);
    const [farm, setFarm] = useState(null);   // { id, name }
    const [date, setDate] = useState(today());
    const [remarks, setRemarks] = useState('');

    const submit = async () => {
        if (!farm) { toast.error('Elegí la finca destino'); return; }
        if (!date) { toast.error('Elegí la fecha del traslado'); return; }
        const payload = { to_farm_id: farm.id, date };
        if (remarks.trim()) payload.remarks = remarks.trim();
        try {
            await transfer(payload);
            toast.success('Vaca trasladada de finca');
            onSaved?.();
        } catch (er) {
            if (er?.status === 400) toast.error('Elegí finca destino y fecha');
            else if (er?.status === 404) toast.error('Animal o finca destino no encontrada');
            else if (er?.status !== 403) toast.error(er?.message || 'No se pudo trasladar');
        }
    };

    return (
        <div className="tff-modal" role="dialog" aria-modal="true" aria-label="Trasladar de finca">
            <div className="tff-modal__overlay" onClick={onClose} aria-hidden="true" />
            <div className="tff-modal__card" ref={cardRef}>
                <header className="tff-modal__head">
                    <div>
                        <h2 className="tff-modal__title">Trasladar de finca</h2>
                        <span className="tff-modal__sub">{currentFarm?.name ? `Finca actual: ${currentFarm.name}` : 'Sin ubicación registrada'}</span>
                    </div>
                    <button type="button" className="tff-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="tff-form">
                    <label className="tff-field">
                        <span className="tff-label">Finca destino</span>
                        {!farm ? (
                            <ClientFarmSearch scope="all" farmsOnly placeholder="Buscar finca…" onSelect={(f) => setFarm(f)} />
                        ) : (
                            <span className="tff-chip">{farm.name}<button type="button" className="tff-chip__x" onClick={() => setFarm(null)} aria-label="Cambiar finca">×</button></span>
                        )}
                    </label>
                    <label className="tff-field">
                        <span className="tff-label">Fecha del traslado</span>
                        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} disabled={busy} />
                    </label>
                    <label className="tff-field">
                        <span className="tff-label">Notas <em>(opcional)</em></span>
                        <input type="text" value={remarks} onChange={(e) => setRemarks(e.target.value)} disabled={busy} />
                    </label>
                    <p className="tff-note">Cambio de ubicación puro: registra dónde está la vaca. No afecta manejos ni pensión (eso va por Estadías).</p>
                </div>

                <footer className="tff-modal__foot">
                    <button type="button" className="tff-btn tff-btn--ghost" onClick={onClose} disabled={busy}>Cancelar</button>
                    <button type="button" className="tff-btn tff-btn--primary" onClick={submit} disabled={busy || !farm}>{busy ? 'Trasladando…' : 'Trasladar'}</button>
                </footer>
            </div>
        </div>
    );
}
